<template>
  <div>
    <Grid
      ref="tableMain"
      :height="height"
      :loading="loading"
      :tablePage="page"
      :tableData="tableData"
      @radio-change="(row) => $emit('radio-change', row)"
    >
      <PageHeader
        ref="header"
        slot="header"
        @query="getData"
        @reset="resetPage"
      />
      <pagination
        slot="pager"
        :current-page="page.curPage"
        :page-size="page.pageSize"
        :page-total="page.pageTotal"
        @change="handlePaginationChange"
      />
    </Grid>
  </div>
</template>
<script>
import Grid from './grid.vue'
import PageHeader from './header'
import BaseTable from '@/mixins/base-table'
export default {
  mixins: [BaseTable],
  components: { Grid, PageHeader },
  props: {
    height: { type: Number, default: 500 },
    goodsMarker: { type: String, default: '' },
  },
  data() {
    return { usePage: true }
  },
  methods: {
    getData(form) {
      this.loading = true
      this.$api
        .mrpPendingGoodsInspectionOptionsApi({
          ...form,
          ...this.page,
          goodsMarker: this.goodsMarker,
        })
        .then((res) => {
          this.loading = false
          this.setData(res)
        })
    },
  },
}
</script>
